import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../theme';
import { useIsMobile } from '../../../../../../utils';
import { BaseButton } from '../../../../../../BaseComponents';
import { getSelectedSegmentMinDate, getSelectedSegmentOnLeg, getSelectedSegmentsDates, transformSegmentToParams } from '@entities/exchange';
import { CdnIcon } from '@shared/ui';
import { SelectDate } from '../SelectDate';
import { useSelectSegmentDate } from '../../model/useSelectSegmentDate';
const SelectSegmentDate = ({ segmentId }) => {
    const { t } = useTranslation('Exchange');
    const { SelectSegmentDate: theme } = useTheme('Features').Exchange;
    const isMobile = useIsMobile();
    const selectedSegment = useSelector(getSelectedSegmentOnLeg);
    const selectedSegmentMinDate = useSelector(getSelectedSegmentMinDate);
    const selectedSegmentsDates = useSelector(getSelectedSegmentsDates);
    const { onSetSegmentDate } = useSelectSegmentDate();
    const onSelectSegmentDate = useCallback((date) => {
        onSetSegmentDate(segmentId, date);
    }, [segmentId, onSetSegmentDate]);
    return (React.createElement(SelectDate, { date: selectedSegment.selectedDate, minDate: selectedSegmentMinDate, selectedDates: selectedSegmentsDates, segmentSearchParams: transformSegmentToParams(selectedSegment), renderTrigger: onOpen => isMobile ? (React.createElement("div", { className: theme.root, onClick: onOpen },
            React.createElement(CdnIcon, { icon: "Action/Show Calendar" }),
            React.createElement("span", { className: theme.label }, t('Flights.ChangeDate')))) : (React.createElement(BaseButton, { variant: "text", onClick: onOpen, endIcon: React.createElement(CdnIcon, { icon: "Action/Show Calendar" }) }, t('Flights.ChangeDate'))), onSelectDate: onSelectSegmentDate, isSelected: true }));
};
export default SelectSegmentDate;
